function normalizeRestrictedInput(value) {
	return value.replace(/[^a-z0-9æøå\n\r\-\.\*\(\)\[\]\{\}_,:;?<>\|"'\+\&\^%\$\#\@\!`~\\\/\s]/ig, "");
}

module.exports = {
	normalizeRestrictedInput
};